import { AfterViewInit, Directive, ElementRef, EventEmitter, HostListener, inject, Input, Output } from '@angular/core';

@Directive()
export class SvcBtnIconBaseComponent implements AfterViewInit {
  @Input() public color: 'primary' | 'on-primary' | 'danger' | 'text' = 'primary';
  @Input() public icon: string;
  @Input() public iconSize: number = 4;
  @Input() public autoFocus: string | boolean = false;
  @Input() processing: boolean;

  @Input('disabled') public set setDisabled(value: boolean) {
    if (typeof value !== 'boolean') {
      if (typeof value === 'string') {
        value = value === 'true' || value === '';
      } else {
        value = value ?? false;
      }
    }
    this.disabled = value;
  }

  @Output('onClick') click = new EventEmitter<MouseEvent>();

  protected elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  protected disabled: boolean = false;

  ngAfterViewInit(): void {
    if (['', 'true'].includes(this.autoFocus?.toString())) {
      this.elementRef?.nativeElement?.focus();
    }
  }

  @HostListener('click', ['$event']) protected onClick(event: MouseEvent): void {
    if (this.processing) {
      event.stopImmediatePropagation();
      event.stopPropagation();
      event.preventDefault();
    } else {
      !this.disabled && this.click.emit(event);
    }
  }
}

